module.exports = __webpack_public_path__ + "static/img/webdesign-03.e037d258.jpg";